module.exports = __webpack_public_path__ + "static/media/co_img.f06bea11.png";